import { api } from './api'

export interface IDateFilter {
  startDate?: string
  endDate?: string
  id?: string
}

export interface IStats {
  total_sales: number
  total_bookings: number
  total_customers: number
}

export const analyticsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getStats: build.query<IStats, IDateFilter>({
      query: (params) => {
        const { startDate, endDate } = params
        const filterBy = `filter_by=created_at:">=${startDate}" created_at:"<=${endDate}"`

        return {
          url: `/dashboard?${filterBy}`
        }
      },
      providesTags: (_result) => {
        return [{ type: 'DashboardStats', id: 'DASHBOARD-LIST' }]
      }
    })
  })
})

export const { useGetStatsQuery } = analyticsApi
